import { messages } from "./i18n";
import { getLanguage } from "./locale";

const locale: string = messages[getLanguage()]['message'];

export function formatStatus(status: string | null): string {
    const array_status = [
        { key: null, value: locale['status']['invoiced'] },
        { key: 'canceled', value: locale['status']['cancelled'] },
        { key: 'returned', value: locale['status']['returned'] },
        { key: 'return_cancellation', value: locale['status']['return_cancelled'] }
    ];

    return array_status.findIndex(s => s.key == status) != -1 ? array_status[array_status.findIndex(s => s.key == status)].value : locale['status']['invoiced'];
}

export function formatCategory(category: string | null): string {
    const array_category = [
        { key: null, value: locale['common']['invoice'] },
        { key: 'invoice', value: locale['common']['invoice'] },
        { key: 'cross', value: locale['common']['cross'] }
    ];

    return array_category.findIndex(s => s.key == category) != -1 ? array_category[array_category.findIndex(s => s.key == category)].value : locale['common']['invoice'];
}

export function formatTinyInt(tinyInt: number | string): string {
    if (Number(tinyInt) == 1) return locale['common']['yes']
    else return locale['common']['no'];
}

export function formatPenality(penality_id: any): string {
    return !penality_id ? locale['common']['no'] : locale['common']['yes'];
}

export function isCross(category: string | null): boolean {
    return formatCategory(category) === 'Cross' ? true : false;
}

export function formatRoleName(role: string | undefined): string {
    if (role == 'Vendedor') {
        return locale['common']['seller'];
    }
    else if (role == 'Inside') {
        return locale['common']['inside'];
    }
    else if (role == 'Gerente') {
        return locale['common']['managers'];
    }
    else if (role == 'ADM') {
        return locale['common']['adm_brand'];
    }
    else if (role == 'Engenheiro') {
        return locale['common']['eng'];
    }
    else if (role == 'BDM') {
        return locale['common']['bdm'];
    }
    else if (role == 'Intermediário') {
        return locale['common']['intermediary'];
    }
    return '';
}






